import React, { useState } from "react";
import { Modal, Form, Input, Button, message, Upload, Spin } from "antd";
import axios from "axios";
import { BASE_URL } from "../constants/Constants";
import { UploadOutlined } from "@ant-design/icons";

const AddCategoryForm = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [thumbnailFileList, setThumbnailFileList] = useState([]);

  const handleThumbnailFileChange = ({ fileList }) => {
    setThumbnailFileList(fileList.slice(-1)); // Only keep the last uploaded file
  };

  const handleAddCategory = async () => {
    try {
      const values = await form.validateFields();
      const { categoryName, displayOrder } = values; // Keep displayOrder if you want to send it, otherwise remove

      setIsLoading(true);

      // Prepare form data
      const formData = new FormData();
      if (thumbnailFileList.length > 0) {
        formData.append("categoryPhoto", thumbnailFileList[0].originFileObj);
      } else {
         message.error("Please upload a category image.");
         setIsLoading(false);
         return;
      }

      // Make API request to add category
      // Note: Ensure your backend accepts 'displayOrder' if you are sending it.
      // If not, remove `&displayOrder=${displayOrder}` from the URL.
      const response = await axios.post(
        `${BASE_URL}/category/addCategory?categoryName=${categoryName}&displayOrder=${displayOrder}`,
        formData
      );

      message.success("Category added successfully");
      form.resetFields();
      setThumbnailFileList([]);
      
      // Close modal and refresh after a short delay
      setTimeout(() => {
         onClose();
         window.location.reload(); 
      }, 1000);

    } catch (error) {
      console.error("Add Category Error:", error);
      
      // --- IMPROVED ERROR HANDLING ---
      if (error.response) {
        // Backend returned a response code outside the 2xx range
        const status = error.response.status;
        const errorMsg = error.response.data?.message || error.response.data;

        if (status === 409 || (typeof errorMsg === 'string' && errorMsg.toLowerCase().includes("exist"))) {
            // Handle duplicate category specifically
            message.warning("This Category Name already exists! Please choose another.");
        } else {
            // Handle other server errors
            message.error(`Failed to add: ${errorMsg || "Server Error"}`);
        }
      } else if (error.request) {
        // Request made but no response received
        message.error("Server is not responding. Check your connection.");
      } else {
        // Something else happened
        message.error("An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title="Add Category"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="add"
          style={{
            border: "1px solid rgb(69, 172, 207)",
            color: "rgb(69, 172, 207)",
          }}
          onClick={handleAddCategory}
        >
          {isLoading ? <Spin size="small" /> : "Add Category"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Category Name"
          name="categoryName"
          rules={[
            { required: true, message: "Please enter the category name" },
          ]}
        >
          <Input placeholder="e.g. Electronics" />
        </Form.Item>
        
        {/* If your backend doesn't use displayOrder, you can remove this Form.Item */}
        <Form.Item
          label="Display Order"
          name="displayOrder"
          rules={[
            {
              required: true,
              message: "Please enter the display order",
            },
          ]}
        >
          <Input type="number" placeholder="e.g. 1" />
        </Form.Item>

        <div style={{ color: "green", marginBottom: "10px", fontSize: "12px" }}>
          Note: Recommended image dimensions: 2048 × 1447 pixels.
        </div>
        <Form.Item
          label="Category Thumbnail Image"
          name="categoryThumbnail"
          rules={[
            { required: true, message: "Please upload an image" },
          ]}
        >
          <Upload
            onChange={handleThumbnailFileChange}
            showUploadList={true}
            beforeUpload={() => false} // Prevent auto-upload
            fileList={thumbnailFileList}
            accept="image/*"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Select Image</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCategoryForm;